import Vue from 'vue'
import { toCamelCase } from '@/helpers/general'
import moment from 'moment-timezone'
import { gsap } from 'gsap'
import { portalState } from '@/state'

export const generatePassword = () => {
  const length = 12
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!#$%&*?@'
  let generatedPassword = ''
  for (let i = 0, n = charset.length; i < length; ++i) {
    generatedPassword += charset.charAt(Math.floor(Math.random() * n))
  }
  return generatedPassword
}

export const isMobile = () => window.matchMedia('only screen and (max-width: 760px)').matches && window.matchMedia('(orientation: portrait)').matches && 'ontouchstart' in document.documentElement

export const testEnvironment = () => {
  const testEnvironments = ['localhost', 'acc.', 'staging.']
  const environmentIndex = testEnvironments.findIndex(v => location.host.includes(v))
  if (environmentIndex !== -1) return testEnvironments[environmentIndex]
  return false
}

export default Vue.mixin({
  methods: {
    generatePassword,
    hasPermission (permission) {
      const { permissions } = portalState.user
      return permissions?.some((p) => p === permission) || false
    },
    gsapFadeIn () {
      gsap.to('.fade-in', { duration: 0.6, opacity: 1 })
    },
    pad (num) {
      return ('0' + num).slice(-2)
    },
    /**
     *
     * @param s {string|null}
     * @param component {string|null}
     * @param view {string|null}
     * @param params
     *
     * @returns {string|void}
     */
    t ({ s = null, component = null, view = null }, ...params) {
      if (!s) {
        return
      }

      // Get component name..
      component = component || this.$options._componentTag

      // convert string to camelCase
      const string = toCamelCase(s)

      if (!component) {
        return this.$vuetify.lang.t(`$vuetify.${view}.${string}`, ...params)
      }

      if (!view && component) {
        return this.$vuetify.lang.t(`$vuetify.${component}.${string}`, ...params)
      }

      return this.$vuetify.lang.t(`$vuetify.${view}.${component}.${string}`, ...params)
    },
    downloadCSV (args) {
      let link, data, filename
      let csv = this.convertArrayOfObjectsToCSV({
        data: args.data
      })
      if (csv == null) {
        return
      }

      filename = args.filename || 'export.csv'

      if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv
      }
      data = encodeURI(csv)

      link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', filename)
      link.click()
    },
    setCookie (name, value, days= 7) {
      const date = new Date
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      document.cookie = `${name}=${value}; expires=${date.toUTCString()}`
    },
    getCookie (name) {
      const cookies = document.cookie.split(';')
      const cookie = cookies.filter(c => c.includes(name))[0]
      if (!cookie) return null
      return cookie.split('=')[1]
    },
    convertArrayOfObjectsToCSV (args) {
      let result, ctr, keys, columnDelimiter, lineDelimiter, data

      data = args.data || null
      if (data == null || !data.length) {
        return null
      }

      columnDelimiter = args.columnDelimiter || ';'
      lineDelimiter = args.lineDelimiter || '\n'

      keys = Object.keys(data[0])

      result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter

      data.forEach(item => {
        if (item) {
          ctr = 0
          keys.forEach(key => {
            if (ctr > 0) {
              result += columnDelimiter
            }

            result += item[key] ? item[key] : ''
            ctr++
          })
          result += lineDelimiter
        }
      })

      return result
    },
    async sweetAlert (text) {
      return await this.$swal({
        title: this.t({s: 'missing.modalTitle', component: 'EntityManagement' }),
        text: text,
        icon: 'warning',
        showCloseButton: false,
        showCancelButton: true,
        cancelButtonText: this.t({s: 'stepper.cancel', component: 'EntityManagement' }),
        confirmButtonText: this.t({s: 'stepper.continue', component: 'EntityManagement' }),
        confirmButtonColor: '#1cad73',
        customClass: {
          title: this.$vuetify.theme.dark ? 'swal2-dark' : '',
          container: this.$vuetify.theme.dark ? 'swal2-dark' : '',
          content: this.$vuetify.theme.dark ? 'swal2-dark' : ''
        }
      })
    },
    redirectTo (router, data) {
      router.push({ path: data.path, query: { search: data.query } })
    },

    dateTimeToLocal (date) {
      if (!date) return
      return moment(moment.utc(date).toDate()).local().format('DD-MM-YYYY HH:mm')
    },
    hhmmss (secs) {
      let minutes = Math.floor(secs / 60)
      secs = secs % 60
      const hours = Math.floor(minutes / 60)
      minutes = minutes % 60
      return this.pad(hours) + ':' + this.pad(minutes)
    },
    /**
     * @param {*} amount
     * @param {number} decimalCount
     * @param decimal
     * @param {string} thousands
     */
    formatMoney (amount, decimalCount = 2, decimal = '.', thousands = ',') {
      try {
        amount = amount && amount.includes(',') ? amount.replace(',', '.') : amount
        decimalCount = Math.abs(decimalCount)
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount

        const negativeSign = amount < 0 ? '-' : ''

        const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
        const j = (i.length > 3) ? i.length % 3 : 0

        return negativeSign + (j ? i.substr(0, j) + thousands : '') +
          i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
          (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
      } catch (e) {
        console.error(e.message)
      }
    }
  }
})
